const e = {
  label3: {
    fontSize: "2xs",
    lineHeight: "label3",
    fontWeight: "bold",
    textTransform: "uppercase"
  },
  headline2: {
    fontSize: "headline2"
  },
  headline3: {
    fontSize: "headline3",
    lineHeight: "headline3",
    fontWeight: "bold"
  },
  title5: {
    fontSize: "sm",
    lineHeight: "label",
    fontWeight: "bold"
  }
}, t = {
  lineHeight: "label",
  pb: 1
}, i = {
  text: e,
  textFontVerticalAlign: t
};
export {
  i as textTheme
};
